import { browser } from '$app/environment'
import type { MenuItem, NavigationItemType } from '$lib/components/menu/Menu'
import { getScrollBuffer } from '$lib/utils/scrollBuffer'
import { getContext, setContext } from 'svelte'

const GLOBALS = Symbol('GLOBALS')

export function createPayloadContext(): PayloadContext {
      return setContext(GLOBALS, new PayloadContext())
}

export function getPayloadContext(): PayloadContext {
      return getContext(GLOBALS)
}

export class PayloadContext {
      navigation: MenuItem[] = $state([])
      localizedNavigation: MenuItem[] = $state([])
      footer: any = $state({})
      livePreview: string | false = $state(false)
      page: any = $state({})
      seo: any = $state({})
      socials: any = $state([])

      constructor() {
            this
      }

      setNavigation(items: NavigationItemType[]) {
            this.navigation = [...parseNavigationItems(items)]
            return this
      }

      setLocalizedNavigation(items: MenuItem[]) {
            this.localizedNavigation = [...items]
            return this
      }

      setFooter(editor: any) {
            this.footer = editor
            return this
      }

      setLivePreview(state: any) {
            this.livePreview = state
            return this
      }

      setPage(state: any, liveUpdate = false) {
            const scrollBuffer = getScrollBuffer()
            this.page = state
            if (liveUpdate == true) {
                  scrollBuffer()
            }
            return this
      }

      setSeo(state: any) {
            this.seo = state
            return this
      }

      setSocials(state: any) {
            //console.log(state)
            this.socials = state
            return this
      }
}

function parseNavigationItems(items: NavigationItemType[]): MenuItem[] {
      return items.map(parseNavigationItem).filter((v) => v != undefined)
}

function parseNavigationItem(item: any): MenuItem | undefined {
      switch (item.type) {
            case 'internal':
                  if (item.page.relationTo) {
                        return {
                              type: item.type,
                              label: item.title_override || item.page.value.title,
                              path: item.page.relationTo,
                              slug: item.page.value.slug,
                        }
                  }
                  return {
                        type: item.type,
                        label: item.title_override || item.page.title,
                        path: `${item.page.id}`,
                  }
            case 'link':
                  return {
                        type: item.type,
                        label: item.title,
                        link: item.link,
                  }
            case 'menu':
                  const menu = parseNavigationItems(item.menu)
                  return {
                        type: item.type,
                        label: item.title,
                        items: menu,
                  }
      }
}
